
import { Vue, Component, Prop } from "vue-property-decorator";
// import UiButton from "@/components/button/ui-button.vue";
import UiButtonTests from "@/components/button/ui-buttontests.vue";
import ClientEditModal from "@/components/companyProjects/ClientEditModal.vue";
import PlusIcon from "@/components/icons/PlusIconNew.vue";
import HoveredIcon from "@/components/icons/HoveredIcon.vue";
import UIButton from "@/components/button/ui-button.vue";
import { User } from "@/generated/graphql";

@Component({
  components: {
    HoveredIcon,
    UiButtonTests,
    ClientEditModal,
    UIButton,
    PlusIcon,
  },
})
export default class ProjectModalWithButton extends Vue {
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: String, default: undefined }) readonly size?: string;
  @Prop({ type: String, default: undefined }) readonly buttonText?: string;
  @Prop({ type: String, default: undefined }) readonly id?: string;
  dialog: boolean = false;
  activeTab = "basic";
  currentEditTab = { tab: 0, step: 0 };

  toggle(): void {
    this.dialog = true;
  }

  get text(): string {
    if (!this.buttonText) {
      return "Add client";
    }
    return this.buttonText;
  }
  handleClose(): void {
    this.dialog = false;
    window.location.reload();
  }
  hanldeCancel(): void {
    this.dialog = false;
  }
  get noCompany(): boolean {
    return !this.companyId;
  }
}
